export default "__VITE_ASSET__BWGb0f4e__"